<template>
  <div class="HasRelationShipView">
    <h2 class="gl_form-title">
      {{ mainQuestionStatement }}
    </h2>

    <CardInfoComponent :icon="configurations?.tags.relationshipAlert.icon">
      {{ configurations?.tags.relationshipAlert.label }}
    </CardInfoComponent>

    <RadioButtonGroup
      id="has-relationship"
      :value="hasRelationship"
      v-model="hasRelationship"
      :options="options"
      flex-direction="row"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'

import CardInfoComponent from '@/modules/common/common/components/panels/CardInfoComponent.vue'
import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'

import type { FormAnswersType } from '@/modules/core/models/types'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import DentalConfigurations from '@/modules/dental/common/models/APP/DentalConfigurations'
import { ForWhomEnum } from '@/modules/core/models/enums'

const { t } = useI18n()

defineExpose({ triggerSubmit })

const props = defineProps({
  nextForm: {
    type: Array<String>,
    required: true
  },
  answers: {
    type: Object as PropType<FormAnswersType>,
    default: () => {}
  },
  configurations: DentalConfigurations
})

const hasRelationship = ref(props.answers.hasRelationship)

const options: OptionsValuesInterface[] = [
  {
    label: t('common.choices.yes'),
    value: 'yes'
  },
  {
    label: t('common.choices.no'),
    value: 'no'
  }
]

const mainQuestionStatement = computed(() => {
  const { forWhom, forWhomPeople } = props.answers

  const onlyOneInsured =
    (forWhom === ForWhomEnum.ME_MORE && forWhomPeople === 2) ||
    (forWhom === ForWhomEnum.NOT_ME && forWhomPeople === 1)
  return onlyOneInsured
    ? t('rater.dental.has-relationship.form-legend-one-insured')
    : t('rater.dental.has-relationship.form-legend')
})

function triggerSubmit() {
  const page = nextPage()
  const answers = {
    hasRelationship: hasRelationship.value
  }

  return { page, answers }
}

function nextPage() {
  if (hasRelationship.value === 'no') {
    return props.nextForm[1]
  }
  return props.nextForm[0]
}
</script>